import { render } from "./FilenameOption.vue?vue&type=template&id=63175708"
import script from "./FilenameOption.vue?vue&type=script&lang=ts"
export * from "./FilenameOption.vue?vue&type=script&lang=ts"
script.render = render

export default script